export const isDevMode = process.env.REACT_APP_IS_DEV_MODE === 'true';

export const idToken = process.env.REACT_APP_ID_TOKEN;

export const userData: string = process.env.REACT_APP_USER_DATA || '';
